<template>
    <ExtraDetails
        :experience="user.experience"
        :mobile="user.mobile"
        :setMobile="setMobile"
        :setResidencyCountry="setResidencyCountry"
        :countryOfResidence="country_of_residence"
        :getIsoCodeFromName="getIsoCodeFromName"
    >
        <template slot="header">
            <h1
                class="mb-2"
                v-translate
            >Sign up to SmartCharts</h1>
            <EnrolmentProgress :currentStage="$options.name" />
        </template>
        <template slot="body-title">
            <h3
                class="text-center mb-4"
                v-translate
            >Enter your personal information</h3>
        </template>
        <template
            slot="footer"
            slot-scope="{ submitForm, isValid }"
        >
            <EnrolmentFooter
                :isValid="isValid"
                :submitHandler="submitForm"
                :processStage="processStage"
                :prev="prev"
            />
        </template>
    </ExtraDetails>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import ExtraDetails from '@C/Enrolment/ExtraDetails';
import EnrolmentFooter from './Footer';
import EnrolmentProgress from '@C/EnrolmentProgress';

import EnrolmentMixin from '@M/enrolment';
import autocomplete from '@M/autocomplete';

export default {
    name: 'Personal',
    beforeDestroy() {
        this.bus.$off('update:detail');
        this.bus.$off('form:submit');
    },
    mounted() {
        this.bus.$on('update:detail', this.updateState);
        this.bus.$on('form:submit', this.formHandler);
    },
    computed: {
        ...mapState(['bus']),
        ...mapState({
            country_of_residence: state => state.Enrolment.user.profile.country_of_residence,
        }),
        ...mapState('Enrolment', ['user'])
    },
    methods: {
        ...mapMutations('Enrolment', ['setResidencyCountry', 'setMobile']),
        ...mapMutations('Enrolment', ['updateState']),
        formHandler(e) {
            this.processStage(e);
        }
    },
    components: {
        EnrolmentFooter,
        EnrolmentProgress,
        ExtraDetails
    },
    mixins: [EnrolmentMixin, autocomplete('Enrolment')]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Personal.vue